var React = require('react');

function Siren (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M128.21,134.94a8,8,0,0,1,9-6.87l15.86,2.13a8,8,0,0,1,6.87,9L135.82,320H400L375,120.06A64,64,0,0,0,311.5,64h-175A64,64,0,0,0,73,120.06L48,320h55.54Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M432,352H16A16,16,0,0,0,0,368v64a16,16,0,0,0,16,16H432a16,16,0,0,0,16-16V368A16,16,0,0,0,432,352Z","className":"fa-primary","key":2})]);
}

Siren.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Siren;

Siren.default = Siren;
